import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../utils/global'
import { loadLocationWithMessage } from '../../actions/location'

//import imageSignature from '../../../../impact_bd_server/uploads/signatures/patient_contract/signature_57_8.png'

class GetImage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      img: '',
    }
  }

  componentDidMount() {
    this.getData()
  }

  getData = () => {
    var pid = 0
    if(this.props.authReducer.role == 5) {
      pid = this.props.authReducer.uid
    } else {
      pid = this.props.match.params.pid
    }

    var path_get_img = ''
    if(this.props.path == 'patient_contract_p_signature') {
      path_get_img = 'patient/enroll/get_patient_contract_img'
    } else if(this.props.path == 'patient_contract_c_signature') {
      path_get_img = 'patient/enroll/get_patient_c_contract_img'
    }

    // get image //
    axios({
      method: 'post',
      url: connectNode + path_get_img,
      headers: {
        'Accept': 'application/json',
        //'Content-Type': 'image/png',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: pid,
        contract_id: this.props.match.params.contract_id
      },
    })
    .then((result) => {this.setState({
          img: result['data']
      })
    })
  }

  render() {
    return ( <img src={this.state.img}  /> )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GetImage)
